var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAuthed)?_c('main',{attrs:{"id":"clientBox"}},[(_vm.getRootMediaId)?_c('ClientFiler',{attrs:{"cid":_vm.getClientId,"rid":_vm.getRootMediaId}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }